import { Controller } from "@hotwired/stimulus"

// Adds and removes vehicle lines of the motor vehicle tax return and shows only
// the fields the chosen vehicle category needs.
//
// It computes nothing: the tax is worked out on the server, because the amount
// ends up in the filed return.
export default class extends Controller {
  static targets = ["rows", "row", "template"]

  // Categories whose annual rate follows from the engine displacement
  // (príloha č. 1); everything else is rated by weight and axles, which the
  // taxpayer copies from príloha č. 1a.
  static DISPLACEMENT_CATEGORIES = ["L1e", "L2e", "L3e", "L4e", "L5e", "L6e", "L7e", "M1"]
  // Buses are taxed per day of use, everything else per whole month.
  static DAILY_CATEGORIES = ["M2", "M3"]

  connect() {
    this.rowTargets.forEach((row) => this.applyCategory(row))
  }

  // The blank line is cloned from the server-rendered <template>; only the
  // index inside its name/id attributes is rewritten, so no markup is built
  // from strings here.
  addVehicle() {
    const index = `new_${this.nextIndex()}`
    const fragment = this.templateTarget.content.cloneNode(true)

    fragment.querySelectorAll("[name], [id], [for]").forEach((element) => {
      ;["name", "id", "for"].forEach((attribute) => {
        const current = element.getAttribute(attribute)
        if (current) element.setAttribute(attribute, current.replaceAll("__INDEX__", index))
      })
    })

    const row = fragment.firstElementChild
    this.rowsTarget.appendChild(fragment)
    if (row) this.applyCategory(row)
  }

  removeVehicle(event) {
    const row = event.target.closest("[data-finance-management--vehicle-tax-target='row']")
    if (row) row.remove()
  }

  refreshRow(event) {
    const row = event.target.closest("[data-finance-management--vehicle-tax-target='row']")
    if (row) this.applyCategory(row)
  }

  applyCategory(row) {
    const category = row.querySelector("select[name$='[vehicle_category]']")?.value || ""
    const byDisplacement = this.constructor.DISPLACEMENT_CATEGORIES.includes(category)
    const daily = this.constructor.DAILY_CATEGORIES.includes(category)

    this.toggle(row, "displacement", byDisplacement)
    this.toggle(row, "base-rate", !byDisplacement)
    this.toggle(row, "months", !daily)
    this.toggle(row, "days", daily)
  }

  toggle(row, field, visible) {
    const wrapper = row.querySelector(`[data-field="${field}"]`)
    if (wrapper) wrapper.classList.toggle("d-none", !visible)
  }

  nextIndex() {
    this.counter = (this.counter || 0) + 1
    return this.counter
  }
}
